import { render, staticRenderFns } from "./common_new.vue?vue&type=template&id=9b142364&scoped=true"
import script from "./common_new.vue?vue&type=script&lang=js"
export * from "./common_new.vue?vue&type=script&lang=js"
import style0 from "./common_new.vue?vue&type=style&index=0&id=9b142364&prod&lang=less&scoped=true"
import style1 from "./common_new.vue?vue&type=style&index=1&id=9b142364&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b142364",
  null
  
)

export default component.exports